import { ReactComponent as Rocket } from "./rocket.svg";
import { ReactComponent as Blogs } from "./blogs.svg";
import { ReactComponent as Settings } from "./setting.svg";
import { ReactComponent as PortfolioIcon } from "./portfolio.svg";
import { ReactComponent as JobsIcon } from "./jobs.svg";
import { ReactComponent as CalendarIcon } from "./calendar.svg";
import { ReactComponent as Calendar2 } from "./calendar-2.svg";
import { ReactComponent as CalendarBlank } from "./calendar-blank.svg";
import { ReactComponent as EducationIcon } from "./education.svg";
import { ReactComponent as PersonIcon } from "./person.svg";
import { ReactComponent as MentorIcon } from "./confirmation.svg";
import { ReactComponent as CoachesIcon } from "./coaches.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as MenuIconActive } from "./menu-active.svg";
import { ReactComponent as JobApplicationIcon } from "./job-applications.svg";
import { ReactComponent as Info } from "./info.svg";
import { ReactComponent as UpdateBlog } from "./update-blog.svg";
import { ReactComponent as Logout } from "./log-out.svg";
import { ReactComponent as ChevLeft } from "./chev-left.svg";
import { ReactComponent as ChevRight } from "./chev-right.svg";
import { ReactComponent as Mail } from "./mail.svg";
import { ReactComponent as Lock } from "./lock.svg";
import { ReactComponent as Eye } from "./eye.svg";
import { ReactComponent as EyeDisable } from "./eye-disable.svg";
import { ReactComponent as ArrowRightCircle } from "./arrow-right-circle.svg";
import { ReactComponent as Hamburger } from "./hamburger.svg";
import { ReactComponent as DropDown } from "./dropDown.svg";
import { ReactComponent as Phone } from "./phone.svg";
import { ReactComponent as Cross } from "./cross.svg";
import { ReactComponent as Trash } from "./trash.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as ChevUp } from "./chev-up.svg";
import { ReactComponent as ChevDown } from "./chev-down.svg";
import { ReactComponent as TrashOutline } from "./trash-outline.svg";
import { ReactComponent as User } from "./user.svg";
import { ReactComponent as ImgUpload } from "./image-add.svg";
import { ReactComponent as ArrowLeft } from "./arrow-left.svg";
import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as UserCircleAdd } from "./user-circle-add.svg";
import { ReactComponent as ArrowUp } from "./arrow-up.svg";
import { ReactComponent as ArrowDown } from "./arrow-down.svg";
import { ReactComponent as CameraPlus } from "./camera-plus.svg";
import { ReactComponent as Bell } from "./bell.svg";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as Filter } from "./filter.svg";
import { ReactComponent as Pencil } from "./pencil.svg";
import { ReactComponent as TrashOutline2 } from "./trash-outline-2.svg";
import { ReactComponent as VerticalDots } from "./vertical-dots.svg";
import { ReactComponent as Tick } from "./tick.svg";
import { ReactComponent as ArrowRightOutline } from "./arrow-right-outline.svg";
import { ReactComponent as ArrowLeftCircle } from "./arrow-left-circle.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as Payment } from "./payment.svg";
import { ReactComponent as DashboardStats1 } from "./dashboard-stats-1.svg";
import { ReactComponent as DashboardStats2 } from "./dashboard-stats-2.svg";
import { ReactComponent as DashboardStats3 } from "./dashboard-stats-3.svg";
import { ReactComponent as TickIcon } from "./tick-icon.svg";
import { ReactComponent as Accept } from "./accept.svg";
import { ReactComponent as Reject } from "./reject.svg";
import { ReactComponent as CheckFilledLight } from "./check-filled-light.svg";
import { ReactComponent as CrossFilledLight } from "./cross-filled-light.svg";
import { ReactComponent as Clock } from "./clock.svg";
import { ReactComponent as MakeFellow } from "./make-fellow.svg";
import { ReactComponent as ReAssign } from "./reassign.svg";
import { ReactComponent as Teacher } from "./teacher.svg";
import { ReactComponent as Chat } from "./chat.svg";
import { ReactComponent as Volunteers } from "./d-services.svg";
import { ReactComponent as ProjectsIcon } from "./project.svg";
import { ReactComponent as ProjectsIconActive } from "./project-active.svg";
import { ReactComponent as Sort } from "./sort.svg";
import { ReactComponent as TabImage } from "./tab-image.svg";
import { ReactComponent as TabOverview } from "./tab-overview.svg";
import { ReactComponent as TabFeedback } from "./tab-feedback.svg";
import { ReactComponent as ChatOutline } from "./chat-outline.svg";
import { ReactComponent as UploadFile } from "./fileUpload.svg";
import { ReactComponent as CompleteState } from "./complete-state.svg";
import { ReactComponent as InProgressState } from "./pending-state.svg";
import { ReactComponent as PendingState } from "./waiting-state.svg";
import { ReactComponent as PDFIcon } from "./pdf.svg";
import { ReactComponent as Logo } from "./logo.svg";
import { ReactComponent as ISeeYou } from "./i-see-you.svg";
import { ReactComponent as UnRead } from "./un-read.svg";
import { ReactComponent as ApprovedState } from "./approved-state.svg";
import { ReactComponent as OnGoingState } from "./ongoing-state.svg";
import { ReactComponent as Camera } from "./camera.svg";
import { ReactComponent as EditState } from "./edit-state.svg";
import { ReactComponent as BriefCase } from "./brief-case.svg";
import { ReactComponent as Profile } from "./profile.svg";
import { ReactComponent as ButtonIcon } from "./button-icon.svg";
import { ReactComponent as UnlockIcon } from "./unlock.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as EditIcon2 } from "./edit-icon.svg";
import { ReactComponent as FileAcceptIcon } from "./file-accept 01.svg";
import { ReactComponent as FileAcceptIcon2 } from "./file-accept 02.svg";
import { ReactComponent as HidePassword } from "./hide-password.svg";
import { ReactComponent as LockIcon } from "./lock-icon.svg";
import { ReactComponent as S } from "./S.svg";
import { ReactComponent as DummyUser } from "./dummy-user.svg";
import { ReactComponent as DummyEmail } from "./dummy-email.svg";
import { ReactComponent as DustBin } from "./dust-bin.svg";
import { ReactComponent as BellIcon } from "./notification.svg";
import { ReactComponent as DummyPhone } from "./dummy-phone.svg";
import { ReactComponent as DummyMessage } from "./dummy-message.svg";
import { ReactComponent as ArrowRightCircleWhite } from "./arrow-right-circle-white.svg";
import { ReactComponent as ChatNotificationIcon } from "./chat-notification.svg";
import { ReactComponent as ImgUploadIcon } from "./img-upload.svg";
import { ReactComponent as TickCircleIcon } from "./tick-circle.svg";
import { ReactComponent as IdeaIcon } from "./idea.svg";
import { ReactComponent as CheckMarkCircleIcon } from "./check mark-circle.svg";
import { ReactComponent as CheckMarkCircleIcon2 } from "./check mark-circle2.svg";
import { ReactComponent as DocumentIcon } from "./document.svg";
import { ReactComponent as BriefCaseIcon } from "./briefcase 04.svg";
import { ReactComponent as DownloadIcon2 } from "./download-2.svg";
import { ReactComponent as AttachIcon } from "./attachment.svg";
import { ReactComponent as MonotonIcon } from "./Monotoneadd.svg";
import { ReactComponent as MonotonIcon1 } from "./Monotoneadd1.svg";
import { ReactComponent as MonotonIcon2 } from "./Monotoneadd2.svg";
import { ReactComponent as MonotonIcon3 } from "./Monotoneadd3.svg";
import { ReactComponent as MonotonIcon4 } from "./Monotoneadd4.svg";
import { ReactComponent as MonotonIcon5 } from "./Monotoneadd5.svg";
import { ReactComponent as MonotonIcon6 } from "./Monotoneadd6.svg";
import { ReactComponent as MonotonIcon7 } from "./Monotoneadd7.svg";
import { ReactComponent as MonotonIcon8 } from "./Monotoneadd8.svg";
import { ReactComponent as WarningIcon } from "./warning.svg";
import { ReactComponent as SuccessModalIcon } from "./success-modal.svg";
import { ReactComponent as SendIcon } from "./send.svg";
import { ReactComponent as ProjectIcon2 } from "./project-icon2.svg";
import { ReactComponent as DocumentIcon2 } from "./document-icon2.svg";
import { ReactComponent as SettingsIcon2 } from "./settings-icon2.svg";
import { ReactComponent as ChatIcon2 } from "./chat-icon2.svg";
import { ReactComponent as FileSuccessIcon } from "./file-success.svg";
import { ReactComponent as ChatIcon3 } from "./chat-icon-3.svg";
import { ReactComponent as GreenTick } from "./green-tick.svg";
import { ReactComponent as EyeEnable } from "./eye-enable.svg";
import { ReactComponent as DwgIcon } from "./dwg.svg";
import { ReactComponent as PngIcon } from "./png.svg";
import { ReactComponent as PdfIcon } from "./pdf-upload.svg";
import { ReactComponent as JpgIcon } from "./jpg.svg";
import { ReactComponent as DragIcon } from "./drag.svg";
import { ReactComponent as CameraIcon2 } from "./camera2.svg";
import { ReactComponent as AddUsersIcon } from "./add-users.svg";
import { ReactComponent as NewCommentIcon } from "./new_comment.svg";
import { ReactComponent as NewReplyIcon } from "./new_reply.svg";
import { ReactComponent as ProjectCompletedIcon } from "./project_completed.svg";
import { ReactComponent as ProjectCreatedIcon } from "./project_created.svg";
import { ReactComponent as ProjectOnboardedIcon } from "./project_onboarded.svg";
import { ReactComponent as ProjectStatusChangedIcon } from "./project_status_changed.svg";
import { ReactComponent as RevisionUploadedIcon } from "./revision_uploaded.svg";
import { ReactComponent as ClientRespondedIcon } from "./client_responded.svg";
import { ReactComponent as NoHome } from "./no-home.svg";
import { ReactComponent as NoNotifications } from "./no-notifications.svg";
import { ReactComponent as NoRevisions } from "./no-revisions.svg";
import { ReactComponent as NoChatBoard } from "./no-chat-board.svg";
import { ReactComponent as NoFeedBack } from "./no-feedback.svg";
import { ReactComponent as BlueFileUpload } from "./file-upload.svg";
import { ReactComponent as FileUploadGlyph } from "./file-upload-glyph.svg";
import { ReactComponent as UploadRevisionIcon } from "./upload-revision.svg";
import { ReactComponent as RightArrow } from "./arrow-right-circle-white.svg";
import { ReactComponent as NoNotificationsIcon } from "./no-notifications.svg";
import { ReactComponent as NoRevisionsIcon } from "./no-revisions.svg";
import { ReactComponent as NoFeedbackIcon } from "./no-feedback.svg";
import { ReactComponent as NoMessagesIcon } from "./no-messages.svg";
import { ReactComponent as FilePdfIcon } from "./file-pdf.svg";
import { ReactComponent as ArchiveIcon } from "./archive.svg";
import { ReactComponent as ArchiveRemoveIcon } from "./archive-remove.svg";
import { ReactComponent as EyeProjectIcon } from "./eye-project.svg";
import { ReactComponent as InformationCircleIcon } from "./information-circle.svg";
import { ReactComponent as ArchiveIconActive } from "./archive-active.svg";
import { ReactComponent as ArchiveInactiveIcon } from "./archive-inactive.svg";

const Icons = {
  Blogs,
  Settings,
  Info,
  UpdateBlog,
  BriefCaseIcon,
  DownloadIcon2,
  CheckMarkCircleIcon2,
  CameraIcon2,
  AddUsersIcon,
  NewCommentIcon,
  NewReplyIcon,
  ProjectCompletedIcon,
  ProjectCreatedIcon,
  ProjectOnboardedIcon,
  ProjectStatusChangedIcon,
  RevisionUploadedIcon,
  ClientRespondedIcon,
  FileAcceptIcon2,
  TickIcon,
  Rocket,
  Logout,
  ProjectIcon2,
  DocumentIcon2,
  SettingsIcon2,
  ChatIcon2,
  ChevLeft,
  ChevRight,
  ArrowLeftCircle,
  CheckMarkCircleIcon,
  AttachIcon,
  MonotonIcon,
  MonotonIcon1,
  MonotonIcon2,
  MonotonIcon3,
  MonotonIcon4,
  MonotonIcon5,
  MonotonIcon6,
  MonotonIcon7,
  MonotonIcon8,
  DocumentIcon,
  IdeaIcon,
  EditIcon2,
  FileAcceptIcon,
  Mail,
  Lock,
  Eye,
  EyeDisable,
  UserCircleAdd,
  EditIcon,
  Hamburger,
  DropDown,
  Phone,
  Cross,
  Trash,
  Search,
  ChevUp,
  ChevDown,
  TrashOutline,
  ImgUpload,
  User,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  CameraPlus,
  Bell,
  Plus,
  Filter,
  Pencil,
  TrashOutline2,
  VerticalDots,
  Tick,
  ArrowRightOutline,
  Download,
  Payment,
  DashboardStats1,
  DashboardStats2,
  DashboardStats3,
  Accept,
  Reject,
  CheckFilledLight,
  CrossFilledLight,
  PortfolioIcon,
  JobsIcon,
  CalendarIcon,
  Calendar2,
  CalendarBlank,
  EducationIcon,
  PersonIcon,
  MentorIcon,
  MenuIcon,
  CoachesIcon,
  MenuIconActive,
  JobApplicationIcon,
  Clock,
  MakeFellow,
  ReAssign,
  Teacher,
  Chat,
  Volunteers,
  ArrowRightCircle,
  ProjectsIcon,
  ProjectsIconActive,
  Sort,
  TabImage,
  TabOverview,
  TabFeedback,
  ChatOutline,
  UploadFile,
  CompleteState,
  InProgressState,
  PendingState,
  PDFIcon,
  Logo,
  ISeeYou,
  UnRead,
  ApprovedState,
  OnGoingState,
  Camera,
  EditState,
  BriefCase,
  Profile,
  ButtonIcon,
  UnlockIcon,
  LockIcon,
  HidePassword,
  S,
  DummyEmail,
  DummyUser,
  DustBin,
  BellIcon,
  DummyPhone,
  DummyMessage,
  ArrowRightCircleWhite,
  ChatNotificationIcon,
  ImgUploadIcon,
  TickCircleIcon,
  WarningIcon,
  SuccessModalIcon,
  SendIcon,
  FileSuccessIcon,
  ChatIcon3,
  GreenTick,
  EyeEnable,
  DwgIcon,
  PngIcon,
  PdfIcon,
  JpgIcon,
  DragIcon,
  NoHome,
  NoNotifications,
  NoRevisions,
  NoFeedBack,
  NoChatBoard,
  BlueFileUpload,
  FileUploadGlyph,
  UploadRevisionIcon,
  RightArrow,
  NoNotificationsIcon,
  NoRevisionsIcon,
  NoFeedbackIcon,
  NoMessagesIcon,
  FilePdfIcon,
  ArchiveIcon,
  ArchiveRemoveIcon,
  EyeProjectIcon,
  InformationCircleIcon,
  ArchiveIconActive,
  ArchiveInactiveIcon,
};

export { Icons };
